import { observer } from 'mobx-react';
import OpenLink from '../../../assets/images/open-link.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store';

export const PricesReview = observer(() => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { quoteStore, signUpStore, shippingInformationStore } = useStore();
  const { quoteShortInfo } = signUpStore;

  return (
    <div className={'container-grey m-bottom-30 avoid-break'}>
      <div className={'quote-title'}>
        <span>{t('QUOTE', { data: quoteStore.quoteInfo?.id })}</span>
        <a target="_blank" href={quoteShortInfo?.html} data-html2canvas-ignore="true">
          <img src={OpenLink} title="quote link" alt="quote link" />
        </a>
      </div>

      <div className={'d-flex conf-charges'}>
        {!quoteShortInfo?.hasNoAdditions && (
          <div className="container-readonly">
            <label>{t('ONE_TIME_CHARGES')}</label>
            <span>{quoteShortInfo?.nrc}</span>
          </div>
        )}

        {quoteShortInfo?.hasPromo && !quoteShortInfo?.hasNoAdditions && (
          <div className="container-readonly">
            <label>
              <span>
                {t(quoteShortInfo.promoDuration > 1 ? 'PROMOTIONAL_CHARGES_PLURAL' : 'PROMOTIONAL_CHARGES', {
                  duration: quoteShortInfo.promoDuration,
                })}
              </span>
            </label>
            <span>{quoteShortInfo.promoMrc}</span>
          </div>
        )}
        {(!quoteShortInfo?.hasNoAdditions || quoteShortInfo.isRenewal) && (
          <div className="container-readonly">
            <label>
              <span>{t(quoteShortInfo?.hasPromo ? 'SUBSEQUENT_CHARGES' : 'RECURRING_CHARGES')}</span>
            </label>
            <span>{quoteShortInfo?.mrc}</span>
          </div>
        )}
        {quoteShortInfo?.isUpgrade && (
          <div className="container-readonly">
            <label>{t('RECURRING_CHARGES_AFTER_UPGRADE')}</label>
            <span>{quoteShortInfo?.upgradeMrc}</span>
          </div>
        )}
        {quoteStore.displayShippingOptions && !quoteShortInfo?.hasNoAdditions && (
          <div className="container-readonly">
            <label>{t('ESTIMATED_SHIPPING_CHARGES')}</label>
            <span>{shippingInformationStore.formattedShippingInfo}</span>
          </div>
        )}
      </div>
    </div>
  );
});
